module.exports = __webpack_public_path__ + "img/illustrations/slack-view-tracking-example-789f0febde80737a2d8835708c5ae458.svg";